import React, { useState } from "react";
import { fringeBenefitsInputs, inputs } from "../../inputs";
import { RadioButton } from "primereact/radiobutton";
import localeText from "../../../../../../locale";
import { useLocation } from "react-router-dom";

const SearchInputsMap = ({ isDisabled, searchParams, setSearchParams, isAdvancedFilter }) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const inputsToMap = isFringeBenefitsPage ? fringeBenefitsInputs : inputs;

  return (
    <>
      {inputsToMap.map((filter, index) => (
        <div key={index}>
          <div className="font-bold mb-2">{localeText(filter.title)}</div>
          {filter.inputs.map((input, i) => (
            <div className={`flex align-items-center ${isDisabled}`} key={i}>
              <RadioButton
                className={`my-2 ${isDisabled}`}
                inputId={`${input.id}${input.type}${isAdvancedFilter}`}
                value={input.value}
                checked={searchParams[input.type] === input.value}
                onChange={(e) => {
                  setSearchParams((prev) => ({ ...prev, [input.type]: e.value }));
                }}
              />
              <label
                htmlFor={`${input.id}${input.type}${isAdvancedFilter}`}
                className={`ml-2 cursor-pointer ${isDisabled}`}
              >
                {localeText(input.description)}
              </label>
            </div>
          ))}
          {index !== inputs.length - 1 && <hr className="my-4" />}
        </div>
      ))}
    </>
  );
};

export default SearchInputsMap;
